function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.8 11.6001C2.24183 11.6001 2.6 11.9583 2.6 12.4001V15.6001C2.6 16.0419 2.95817 16.4001 3.4 16.4001H14.6C15.0418 16.4001 15.4 16.0419 15.4 15.6001V12.4001C15.4 11.9583 15.7582 11.6001 16.2 11.6001C16.6418 11.6001 17 11.9583 17 12.4001V15.6001C17 16.9256 15.9255 18.0001 14.6 18.0001H3.4C2.07452 18.0001 1 16.9256 1 15.6001V12.4001C1 11.9583 1.35817 11.6001 1.8 11.6001Z",
  fill: "#908E8E",
  stroke: "#908E8E",
  strokeWidth: 0.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.99995 12.7998C9.44178 12.7998 9.79995 12.4416 9.79995 11.9998V3.73118L12.4343 6.36549C12.7467 6.67791 13.2532 6.67791 13.5656 6.36549C13.8781 6.05307 13.8781 5.54654 13.5656 5.23412L9.56564 1.23412C9.25322 0.9217 8.74669 0.9217 8.43427 1.23412L4.43427 5.23412C4.12185 5.54654 4.12185 6.05307 4.43427 6.36549C4.74669 6.67791 5.25322 6.67791 5.56564 6.36549L8.19995 3.73118V11.9998C8.19995 12.4416 8.55812 12.7998 8.99995 12.7998Z",
  fill: "#908E8E",
  stroke: "#908E8E",
  strokeWidth: 0.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgUploadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.5c63a867.svg";
export { ForwardRef as ReactComponent };